<div class="agent">
  <div class="agent-header" *ngIf="chrome">
    <app-juana-avatar size="md" [statusDot]="true"></app-juana-avatar>
    <div class="agent-titles">
      <div class="agent-title">Juana</div>
      <div class="agent-sub">{{ subtitle }}</div>
    </div>
    <button
      class="agent-link"
      type="button"
      (click)="nuevaConversacion()"
      [title]="'repuestos.agent.newConversation' | transloco"
      [attr.aria-label]="'repuestos.agent.newConversation' | transloco"
    >
      <i class="pi pi-plus"></i> {{ 'repuestos.agent.newShort' | transloco }}
    </button>
    <div class="agent-status"><span class="dot"></span> {{ 'repuestos.agent.active' | transloco }}</div>
  </div>

  <div class="agent-body">
    <!-- Bienvenida + sugerencias si no hay mensajes -->
    <div class="agent-welcome" *ngIf="juana.messages().length === 0">
      <div class="welcome-hint">
        {{ 'repuestos.agent.welcome' | transloco }}
      </div>
      <div class="quick-prompts">
        <button class="qp" *ngFor="let q of quickPrompts" [disabled]="juana.busy()" (click)="send(q)">{{ q }}</button>
      </div>
    </div>

    <!-- Mensajes -->
    <ng-container *ngFor="let m of juana.messages(); let i = index">
      <div class="b user" *ngIf="m.role === 'user'">{{ m.content }}</div>

      <div class="bot-row" *ngIf="m.role === 'assistant'">
        <app-juana-avatar size="sm"></app-juana-avatar>
        <div class="b juana">
          <span [innerHTML]="renderRich(m.content || '')"></span><span class="caret" *ngIf="m.streaming">▍</span>
          <!-- Cards inline: se muestran dentro del bubble cuando el siguiente mensaje es una card inlinable -->
          <ng-container *ngIf="getInlineCard(i) as card">
            <div class="inline-fleet-veh" *ngIf="card.kind === 'fleet-vehicles'">
              <div class="inline-divider"></div>
              <div class="fleet-veh-empty" *ngIf="!card.vehicles?.length">
                {{ 'repuestos.agent.noFleetVehicles' | transloco }}
              </div>
              <button class="inline-veh-btn" *ngFor="let v of card.vehicles" [disabled]="juana.busy()" (click)="elegirVehiculo(v)">
                <span class="veh-ico">🚗</span>
                <span class="veh-txt">
                  {{ v.brand }} {{ v.model }} {{ v.year }}<span class="veh-plate" *ngIf="v.plate"> · {{ v.plate }}</span>
                </span>
              </button>
              <button class="inline-veh-btn other" [disabled]="juana.busy()" (click)="sendOtherVehicle()">
                <span class="veh-ico">➕</span> <span class="veh-txt">{{ 'repuestos.agent.otherVehicle' | transloco }}</span>
              </button>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Tarjetas de tool (se omite fleet-vehicles si ya está inlineada arriba) -->
      <div class="cards-row" *ngIf="m.role === 'tool' && m.cards && !isInlinedCard(i)">
        <app-juana-card-renderer
          [card]="m.cards"
          [busy]="juana.busy()"
          [openBuyResponseId]="buyForm?.responseId ?? null"
          [buyFormTpl]="buyFormTpl"
          [openScheduleKey]="scheduleRowKey"
          [scheduleFormTpl]="scheduleFormTpl"
          (chooseVehicle)="elegirVehiculo($event)"
          (otherVehicle)="sendOtherVehicle()"
          (viewRequest)="verSolicitud($event)"
          (buy)="onBuyRequest($event)"
          (fieldOptionSelected)="onFieldOptionSelected($event)"
          (schedule)="onScheduleRequest($event)"
        ></app-juana-card-renderer>
      </div>
    </ng-container>

    <!-- Mini-form de compra (compartido por las cards de oferta) -->
    <ng-template #buyFormTpl>
      <div class="buy-form" *ngIf="buyForm as f">
        <div class="buy-title">{{ 'repuestos.agent.confirmPurchase' | transloco: { provider: f.providerName } }}</div>

        <!-- Cantidad -->
        <div class="buy-field">
          <label class="buy-label">{{ 'repuestos.agent.howManyUnits' | transloco }}</label>
          <div class="buy-stepper">
            <button type="button" (click)="f.qty = f.qty > 1 ? f.qty - 1 : 1" [disabled]="f.qty <= 1">−</button>
            <span class="buy-stepper-num">{{ f.qty }}</span>
            <button type="button" (click)="f.qty = f.qty + 1">+</button>
          </div>
        </div>

        <!-- Entrega: opciones autoexplicativas -->
        <div class="buy-field">
          <label class="buy-label">{{ 'repuestos.agent.howReceive' | transloco }}</label>
          <button
            type="button"
            class="buy-opt"
            *ngIf="canPickup(f)"
            [class.active]="f.deliveryMode === 'pickup'"
            (click)="f.deliveryMode = 'pickup'"
          >
            <span class="buy-opt-ico">🏪</span>
            <span class="buy-opt-body">
              <span class="buy-opt-name">{{ 'repuestos.agent.pickupTitle' | transloco }}</span>
              <span class="buy-opt-desc">{{ 'repuestos.agent.pickupDesc' | transloco }}</span>
            </span>
            <span class="buy-opt-check" *ngIf="f.deliveryMode === 'pickup'">✓</span>
          </button>
          <button
            type="button"
            class="buy-opt"
            *ngIf="canDelivery(f)"
            [class.active]="f.deliveryMode === 'delivery'"
            (click)="f.deliveryMode = 'delivery'"
          >
            <span class="buy-opt-ico">🚚</span>
            <span class="buy-opt-body">
              <span class="buy-opt-name">{{ 'repuestos.agent.deliveryTitle' | transloco }}</span>
              <span class="buy-opt-desc">
                {{ 'repuestos.agent.deliveryDesc' | transloco }} ·
                {{ offerDeliveryFee(f) === 0 ? ('repuestos.agent.freeShipping' | transloco) : '+' + (offerDeliveryFee(f) | currency:'COP':'symbol-narrow':'1.0-0') }}
              </span>
            </span>
            <span class="buy-opt-check" *ngIf="f.deliveryMode === 'delivery'">✓</span>
          </button>
        </div>

        <!-- Dirección de envío (solo domicilio) -->
        <div class="buy-address" *ngIf="f.deliveryMode === 'delivery'">
          <label class="buy-address-lbl">{{ 'repuestos.agent.deliveryAddress' | transloco }}</label>
          <input
            class="buy-address-input"
            type="text"
            [placeholder]="'repuestos.agent.addressPlaceholder' | transloco"
            [(ngModel)]="f.address"
          />
        </div>

        <!-- Desglose de total -->
        <div class="buy-summary" *ngIf="f.unitPrice > 0">
          <div class="buy-sum-row">
            <span>{{ 'repuestos.agent.part' | transloco }} ({{ f.qty }} × {{ f.unitPrice | currency:'COP':'symbol-narrow':'1.0-0' }})</span>
            <span>{{ buySubtotal(f) | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          </div>
          <div class="buy-sum-row" *ngIf="buyServiceFee(f) > 0">
            <span>{{ 'repuestos.agent.pittsService' | transloco }}</span>
            <span>{{ buyServiceFee(f) | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          </div>
          <div class="buy-sum-row" *ngIf="f.deliveryMode === 'delivery'">
            <span>{{ 'repuestos.agent.shipping' | transloco }}</span>
            <span>{{ buyDeliveryFee(f) === 0 ? ('repuestos.agent.free' | transloco) : (buyDeliveryFee(f) | currency:'COP':'symbol-narrow':'1.0-0') }}</span>
          </div>
          <div class="buy-sum-row stripe-fee">
            <span>{{ 'repuestos.agent.paymentProcessing' | transloco }}</span>
            <span>{{ buyStripeFee(f) | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          </div>
          <div class="buy-sum-row total">
            <span>{{ 'repuestos.agent.totalToPay' | transloco }}</span>
            <span>{{ buyTotal(f) | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
          </div>
          <p class="stripe-disclaimer">{{ 'repuestos.agent.stripeDisclaimer' | transloco }}</p>
        </div>

        <div class="buy-actions">
          <button class="offer-cta" [disabled]="f.submitting" (click)="confirmBuy()">
            {{ (f.submitting ? 'repuestos.agent.creating' : 'repuestos.agent.confirmAndPay') | transloco }}
          </button>
          <button class="buy-cancel" type="button" [disabled]="f.submitting" (click)="cancelBuy()">
            {{ 'repuestos.agent.cancel' | transloco }}
          </button>
        </div>
      </div>
    </ng-template>

    <!-- Mini-form de agendar (compartido por las filas de booking-services) -->
    <ng-template #scheduleFormTpl>
      <div class="buy-form" *ngIf="scheduleForm as f">
        <div class="buy-title">{{ 'repuestos.agent.confirmSchedule' | transloco: { provider: f.providerName } }}</div>
        <div class="buy-sum-row">
          <span>{{ f.serviceName }} · {{ f.subServiceName }}</span>
          <span *ngIf="f.price != null">{{ f.price | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
        </div>

        <!-- Vehículo -->
        <div class="buy-field">
          <label class="buy-label">{{ 'repuestos.agent.scheduleVehicleLabel' | transloco }}</label>
          <select class="buy-address-input" [(ngModel)]="f.vehicleId">
            <option value="" disabled>{{ 'repuestos.agent.scheduleVehiclePlaceholder' | transloco }}</option>
            <option *ngFor="let v of vehicles" [value]="v.id">{{ v.plate }} · {{ v.brand }} {{ v.model }}</option>
          </select>
          <div class="fleet-veh-empty" *ngIf="!vehicles.length">{{ 'repuestos.agent.noFleetVehicles' | transloco }}</div>
        </div>

        <!-- Fecha y hora -->
        <div class="buy-field">
          <label class="buy-label">{{ 'repuestos.agent.scheduleDateLabel' | transloco }}</label>
          <input
            class="buy-address-input"
            type="datetime-local"
            [min]="scheduleMinDatetime"
            [(ngModel)]="f.datetime"
          />
        </div>

        <div class="buy-actions">
          <button class="offer-cta" [disabled]="f.submitting" (click)="confirmSchedule()">
            {{ (f.submitting ? 'repuestos.agent.scheduling' : 'repuestos.agent.confirmAndPay') | transloco }}
          </button>
          <button class="buy-cancel" type="button" [disabled]="f.submitting" (click)="cancelSchedule()">
            {{ 'repuestos.agent.cancel' | transloco }}
          </button>
        </div>
      </div>
    </ng-template>

    <!-- Pensando -->
    <div class="bot-row" *ngIf="juana.thinking()">
      <app-juana-avatar size="sm"></app-juana-avatar>
      <div class="b juana typing"><span></span><span></span><span></span></div>
    </div>
  </div>

  <div class="agent-composer" *ngIf="chrome">
    <input
      class="agent-input"
      [placeholder]="placeholder"
      [(ngModel)]="input"
      [disabled]="juana.busy()"
      (keyup.enter)="send()"
    />
    <button
      class="agent-send"
      type="button"
      [disabled]="juana.busy()"
      (click)="send()"
      [attr.aria-label]="'repuestos.agent.send' | transloco"
    >
      <i class="pi pi-arrow-right"></i>
    </button>
  </div>

  <div class="agent-footer" *ngIf="chrome">{{ 'repuestos.agent.poweredBy' | transloco }}</div>
</div>
